/**
 * @generated SignedSource<<571c01cdbf56603bef999051ccc73bab>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type paywallsGetArticlePaywallTagArticle$data = {
  readonly flag: string | null | undefined;
  readonly topics: ReadonlyArray<{
    readonly entityId: string;
  } | null | undefined> | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"helpersCheckIsPlusArticle" | "helpersGetArticleTypeArticle" | "helpersIsArchiveWallArticle" | "helpersIsLiteWallArticle" | "helpersIsPlusInlinePaywall" | "helpersIsSignInWallArticle" | "helpersIsVelocityWallArticle" | "hooksVelocityWallThresholdABTest">;
  readonly " $fragmentType": "paywallsGetArticlePaywallTagArticle";
};
export type paywallsGetArticlePaywallTagArticle$key = {
  readonly " $data"?: paywallsGetArticlePaywallTagArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"paywallsGetArticlePaywallTagArticle">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "paywallsGetArticlePaywallTagArticle"
};

(node as any).hash = "b168f5bfbabccf152c2fbda77db11539";

export default node;
